import { ILocalization } from 'bernie-l10n';

export class SearchValidation {
  private _formatText: ILocalization['formatText'];

  constructor(formatText: ILocalization['formatText']) {
    this._formatText = formatText;

    this.adults = this.adults.bind(this);
    this.children = this.children.bind(this);
    this.destination = this.destination.bind(this);
    this.endDate = this.endDate.bind(this);
    this.formatText = this.formatText.bind(this);
    this.isValidDate = this.isValidDate.bind(this);
    this.startDate = this.startDate.bind(this);
  }

  public adults({ adults }: { adults?: string }) {
    if (!adults || parseInt(adults, 10) <= 0) {
      return this.formatText('hotels.search.validation.invalidGuests.text');
    }
  }

  public children({ children }: { children?: string }) {
    if (!children) {
      return;
    }

    const { formatText } = this;

    const childAges = children.split(',');

    const message =
      childAges.length === 1
        ? formatText('hotels.search.validation.missingChildAge.text')
        : formatText('hotels.search.validation.missingChildrenAges.text');

    let error = false;

    childAges.forEach(child => {
      if (!child.match(/\d{1,2}_\d{1,2}/)) {
        // i.e. roomNumber_childAge, e.g. 1_4
        error = true;
      }
    });

    return error ? message : undefined;
  }

  public destination({ destination }: { destination?: string }) {
    if (!destination) {
      return this.formatText('hotels.search.validation.invalidDestination.text');
    }
  }

  public endDate({ startDate, endDate }: { startDate?: string; endDate?: string }) {
    const { isValidDate, formatText } = this;

    const start: Date = startDate && new Date(startDate);
    const end: Date = endDate && new Date(endDate);

    if (!isValidDate(end)) {
      return formatText('hotels.search.validation.invalidToDate.text');
    }

    if (isValidDate(start)) {
      const maxEndDate = new Date(start.getFullYear(), start.getMonth(), start.getDate() + 28);

      if (end < start) {
        return formatText('hotels.search.validation.invalidDateRange.text');
      }

      maxEndDate.setHours(0, 0, 0, 0);
      end.setHours(0, 0, 0, 0);

      if (end > maxEndDate) {
        return formatText('hotels.search.validation.invalidDateDateRangeLength.text');
      }
    }
  }

  public formatText(key: string, ...args) {
    return this._formatText(key, ...args);
  }

  public isValidDate(date?: Date) {
    return date && date.toString() !== 'Invalid Date';
  }

  public startDate({ startDate }: { startDate?: string }) {
    const { isValidDate, formatText } = this;

    const start: Date = startDate && new Date(startDate);

    if (!isValidDate(start)) {
      return formatText('hotels.search.validation.invalidFromDate.text');
    }
  }
}
